import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { FaCheck, FaTimes, FaUserPlus } from "react-icons/fa"
import TokenService from "../../../services/token_services"
import AdminLayout from "../../../components/AdminLayout"
import bud1 from "../../../media/images/buds/01.png"
import bud2 from "../../../media/images/buds/02.png"
import bud3 from "../../../media/images/buds/03.png"
import bud4 from "../../../media/images/buds/04.png"
import bud5 from "../../../media/images/buds/05.png"
import bud6 from "../../../media/images/buds/06.png"
import bud7 from "../../../media/images/buds/07.png"
import bud8 from "../../../media/images/buds/08.png"
import bud9 from "../../../media/images/buds/09.png"
import bud10 from "../../../media/images/buds/10.png"
import bud11 from "../../../media/images/buds/11.png"
import bud12 from "../../../media/images/buds/12.png"
import bud13 from "../../../media/images/buds/13.png"
import bud14 from "../../../media/images/buds/14.png"
import bud15 from "../../../media/images/buds/15.png"
import bud16 from "../../../media/images/buds/16.png"
import bud17 from "../../../media/images/buds/17.png"
import bud18 from "../../../media/images/buds/18.png"
import bud19 from "../../../media/images/buds/19.png"
import bud20 from "../../../media/images/buds/20.png"
import bud21 from "../../../media/images/buds/21.png"
import bud22 from "../../../media/images/buds/22.png"
import bud23 from "../../../media/images/buds/23.png"
import bud24 from "../../../media/images/buds/24.png"

//Components
import AdminService from "../../../services/admin_services"

const buds = [bud1, bud2, bud3, bud4, bud5, bud6, bud7, bud8, bud9, bud10, bud11, bud12, bud13, bud14, bud15, bud16, bud17, bud18, bud19, bud20, bud21, bud22, bud23, bud24]

class AdminAccounts extends Component {
    constructor(props) {
        super(props)
        this.state = {
            accounts: [],
            deactivated: false,
            account: {},
        }
    }

    componentDidMount = async() => {
        this.loadAccounts()
        const user = await TokenService.getUser()
        this.setState({account: user? user.account : {}})
    }

    loadAccounts = async () => {
        const accounts = await AdminService.getAdmins(this.state.deactivated)
        this.setState({ accounts })
    }

    switchFilter = async () => {
        this.setState({ deactivated: !this.state.deactivated }, () => this.loadAccounts())
    }

    activate = async (admin_uuid) => {
        try {
            const data = await AdminService.activateAdmin(admin_uuid)
            NotificationManager.success(data.message)
            this.loadAccounts()
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        }
    }

    deactivate = async (admin_uuid) => {
        try {
            const data = await AdminService.deactivateAdmin(admin_uuid)
            NotificationManager.success(data.message)
            this.loadAccounts()
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        }
    }

    render() {
        return (
            <>
                <AdminLayout 
                    title="Admin Accounts"
                    breadcrumbs={[{ label: 'Accounts' }]}
                >
                    <div className="space-y-6">
                        {/* Header Actions */}
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                <button
                                    onClick={this.switchFilter}
                                    className={`px-4 py-2 rounded-lg font-medium transition-all ${
                                        this.state.deactivated
                                            ? 'bg-green-100 text-green-700 hover:bg-green-200'
                                            : 'bg-red-100 text-red-700 hover:bg-red-200'
                                    }`}
                                >
                                    {this.state.deactivated ? 'Show Active' : 'Show Deactivated'}
                                </button>
                            </div>
                            <button 
                                onClick={() => window.location.href = '/admin/account/create'}
                                className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all shadow-md hover:shadow-lg font-medium"
                            >
                                <FaUserPlus />
                                Create New Account
                            </button>
                        </div>

                        {/* Accounts Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                            {this.state.accounts.map(acc => (
                                <div key={acc.admin_uuid} className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all overflow-hidden border border-gray-200">
                                    {/* Avatar */}
                                    <div className="relative h-40 bg-gradient-to-br from-blue-500 to-indigo-600">
                                        <img 
                                            src={buds[acc.email_address.toLowerCase().charCodeAt(0) - 97]} 
                                            alt="Avatar"
                                            className="w-full h-full object-cover opacity-20"
                                        />
                                        <div className="absolute top-3 right-3">
                                            <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-indigo-700 text-xs font-semibold rounded-full">
                                                ADMIN
                                            </span>
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <div className="p-4 space-y-3">
                                        <div>
                                            <h3 className="font-semibold text-gray-900 text-lg">
                                                {acc.firstname} {acc.lastname}
                                            </h3>
                                            <p className="text-sm text-gray-600 mt-1">{acc.email_address}</p>
                                        </div>

                                        {/* Actions */}
                                        <div className="flex gap-2 pt-2">
                                            {this.state.account.admin_uuid === acc.admin_uuid && (
                                                <button 
                                                    onClick={() => window.location.href=`/admin/account/update/${acc.admin_uuid}`}
                                                    className="flex-1 px-3 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-sm font-medium"
                                                >
                                                    Update
                                                </button>
                                            )}
                                            {this.state.deactivated ? (
                                                <button 
                                                    onClick={() => this.activate(acc.admin_uuid)}
                                                    className="px-3 py-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors"
                                                    title="Activate"
                                                >
                                                    <FaCheck />
                                                </button>
                                            ) : (
                                                <button 
                                                    onClick={() => this.deactivate(acc.admin_uuid)}
                                                    className="px-3 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors"
                                                    title="Deactivate"
                                                >
                                                    <FaTimes />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminAccounts)